module.exports = " <div class=navigation-menu> <navigationhamburger-component></navigationhamburger-component> <navigationpanel-component></navigationpanel-component> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader?attrs=img:src img:data-fallback-src!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Navigation.vue
// module id = 549
// module chunks = 10